const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const validateUserForm = (form) => {
  const errors = {}
  if (!form.name?.trim()) errors.name = 'Name is required'
  if (!form.email?.trim()) errors.email = 'Email is required'
  else if (!EMAIL_RE.test(form.email)) errors.email = 'Invalid email format'
  return errors
}

export const validateVehicleForm = (form) => {
  const errors = {}
  if (!form.plate?.trim()) errors.plate = 'Plate is required'
  if (form.mileage !== '' && form.mileage != null) {
    const m = Number(form.mileage)
    if (isNaN(m) || m < 0) errors.mileage = 'Mileage must be a positive number'
  }
  return errors
}

export const validateCreateVehicleForm = (form) => {
  const errors = {}
  if (!form.plate?.trim()) errors.plate = 'Plate is required'
  if (!form.plateCountry?.trim()) errors.plateCountry = 'Country is required'
  else if (!/^[A-Z]{2,3}$/.test(form.plateCountry)) errors.plateCountry = 'Must be 2-3 uppercase letters (e.g. BG, DE)'
  if (form.vin && form.vin.length !== 17) errors.vin = 'VIN must be exactly 17 characters'
  return errors
}

export const validateNotificationForm = (form) => {
  const errors = {}
  if (!form.title?.trim()) errors.title = 'Title is required'
  if (!form.message?.trim()) errors.message = 'Message is required'
  if (!form.channels || form.channels.length === 0) errors.channels = 'At least one channel is required'
  if (form.targetType !== 'ALL' && (!form.userIds || form.userIds.length === 0)) {
    errors.userIds = 'At least one user is required'
  }
  return errors
}

export const hasErrors = (errors) => Object.keys(errors).length > 0
